import React, { FC } from 'react'
import { Text } from '@afterpaytouch/core'
import styles from './style.module.css'

export const MerchantAvatarFallback: FC<{ placeholderText: string }> = ({ placeholderText }) => {
  return (
    <div data-testid='merchant-avatar-fallback' className={styles.merchantAvatarFallback}>
      <Text size='S' renderAs='span'>
        {placeholderText}
      </Text>
    </div>
  )
}
